import { useTranslation } from 'react-i18next';

import './LanguageSwitch.styl';

const LANGS = ['es', 'en'] as const;

type Props = { compact?: boolean; className?: string };

/** ES | EN segmented control. The choice persists (localStorage) and sets <html lang>. */
export function LanguageSwitch({ compact = false, className }: Props) {
  const { t, i18n } = useTranslation();
  const current = i18n.language?.startsWith('es') ? 'es' : 'en';
  const classes = ['w-lang'];
  if (compact) classes.push('w-lang--compact');
  if (className) classes.push(className);
  return (
    <div
      className={classes.join(' ')}
      role="group"
      aria-label={t('common.language')}
    >
      {LANGS.map((lng) => (
        <button
          key={lng}
          type="button"
          lang={lng}
          className={
            lng === current ? 'w-lang__opt w-lang__opt--active' : 'w-lang__opt'
          }
          aria-pressed={lng === current}
          title={t(`common.languages.${lng}`)}
          onClick={() => void i18n.changeLanguage(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
